<template>
  <div class="flex-row justify-end pager">
    <v-pagination
      v-if="count > 1"
      v-model="page"
      :length="count"
      :total-visible="10"
      @input="handleInput"
    ></v-pagination>
  </div>
</template>

<script>
import { defineComponent, watch, ref } from "@vue/composition-api";
export default defineComponent({
  components: {},
  name: "Pagination",
  emits: ["cur-page", "on-page-change"],
  props: {
    curPage: {
      type: Number | String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
  },
  setup(props, ctx) {
    const page = ref(Number(props.curPage));
    watch(
      () => props.curPage,
      () => {
        page.value = props.curPage;
      }
    );

    const handleInput = (v) => {
      ctx.emit("update:cur-page", v);
      ctx.emit("on-page-change", v);
    };
    return { page, handleInput };
  },
});
</script>
<style lang="scss" scoped>
.pager {
  overflow: hidden;
  ::v-deep .v-pagination {
    .v-pagination__item,
    .v-pagination__navigation {
      width: 30px;
      height: 30px;
      background: #f6f6f6;
      border-radius: 0;
      box-shadow: 0 0 0;
      background: #f6f6f6;
      font-size: 12px;
      font-weight: 400;
      color: #423e3d;
    }
    .v-pagination__item--active {
      background-color: #423e3d !important;
      color: #fff;
    }
  }
}
</style>
